import logger from '@elab/core/utils/logger';

export const key = {
    reportedReviews: 'reportedReviews',
};

export function set(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        logger.error(error);
    }
}

export function get(key, parse) {
    try {
        const data = sessionStorage.getItem(key);
        const value = data && parse ? JSON.parse(data) : data;

        return value || null;
    } catch (error) {
        logger.error(error);
    }
}

export function remove(key) {
    sessionStorage.removeItem(key);
}
